import { Component, Input } from '@angular/core';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { Platform } from 'ionic-angular';
import { SocialMediaSharingProvider } from '../../providers/social-media-sharing/social-media-sharing';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the CoTwitterFeedComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-twitter-feed',
  templateUrl: 'co-twitter-feed.html',
  inputs: ['blockInfo']
})
export class CoTwitterFeedComponent {
  @Input('blockInfo') blockInfo: any;
  libraryInfo: { name: string, fullLink: string, link: string, cleanLink: any } = { name: '', fullLink: '', link: '', cleanLink: null };
  clientInfo: any;
  result: any;
  tweets: any;
  title: string;
  fromApi: boolean = true;
  constructor(private clientDetails: ClientDetailsProvider, public platform: Platform, private social: SocialMediaSharingProvider, private inAppBrowser: InAppBrowser) {
    let self = this;
    this.clientDetails.load().then((response) => {
      self.clientInfo = response;
      self.libraryInfo.name = response.name;
    });
  }

  getHomeTimeline() {
    this.social.getTweets(this.blockInfo.url, 10).then((res)=>{
      // console.log(res)
      this.tweets = res;
    })
  }

  ngOnInit(): void {
    this.title = this.blockInfo.title;
    if (this.fromApi) this.getHomeTimeline();
  }

  goToTweet(text){
    let url = "https://t.co"+text.split('https://t.co')[1] || "https://twitter.com";
    this.inAppBrowser.create(`${url}`, "_system");
  }

  goToTwitter(){
    this.inAppBrowser.create(`${this.blockInfo.url}`, "_system");
  }

  ngAfterViewInit () {
    // !function(d,s,id){
    //     var js: any,
    //         fjs=d.getElementsByTagName(s)[0],
    //         p='https';
    //     if(!d.getElementById(id)){
    //         js=d.createElement(s);
    //         js.id=id;
    //         js.src=p+"://platform.twitter.com/widgets.js";
    //         fjs.parentNode.insertBefore(js,fjs);
    //     }
    // }
    // (document,"script","twitter-wjs");
  }

}



// WEBPACK FOOTER //
// ./src/components/co-twitter-feed/co-twitter-feed.ts